// the above line makes the linter ignore Sys.* errors, Sys DOES exist, it is part of ASP.Net, but logically it does NOT exist 'here'
// requires for external dependencies and other global stuff go here
/* eslint-disable no-unused-vars */

import helper from './util/helper';
import collapse from '../Scripts/modules/collapse/collapse.module';
import eventListeners from '../Scripts/modules/eventlisteners/eventlisteners.module';
import floatingLabels from '../Scripts/modules/forms/forms.module';
import gallery from '../Scripts/modules/gallery/gallery.module';
import goToPage from '../Scripts/modules/paging/paging.module';
import gridLayout from '../Scripts/modules/grid/grid.module';
import nav from '../Scripts/modules/nav/nav.module';
import sectorMenu from '../Scripts/modules/sectormenu/sectormenu.module';

import './util/polyfill';

/**
 * Bootstrap - Import ONLY if necessary
 **/
// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/index';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/tooltip';
// import 'bootstrap/js/dist/util';

/* eslint-enable no-unused-vars */

function init() {
	floatingLabels();
	gridLayout();
	collapse();
	eventListeners();
	nav();
	sectorMenu();
	gallery();

	const body = document.getElementsByTagName('BODY')[0];
	const target = document.getElementById('specialists');

	function handleIntersection(entries) {
		entries.map((entry) => {
			if (entry.isIntersecting) {
				body.classList.add('specialists-in-viewport');
			} else {
				body.classList.remove('specialists-in-viewport');
			}

			if (entry.boundingClientRect.y < 0) {
				body.classList.add("specialists-above-viewport");
			} else {
				body.classList.remove("specialists-above-viewport");
			}
		});
	}

	if (target != null && "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
		let getRootMargin = '-60px 0px -60px 0px';
		let getTreshold = 0.1;
		if (document.documentElement.clientWidth > 1280) {
			getRootMargin = '-190px 0px -190px 0px';
			getTreshold = 0.1;
		}

		const intersectionOptions = {
			rootMargin: getRootMargin,
			threshold: getTreshold
		};
		const observer = new IntersectionObserver(handleIntersection, intersectionOptions);
		observer.observe(target);
	}

	const backButton = document.getElementById('backbutton');
	if (backButton != null && document.referrer) {
		const referrer = new URL(document.referrer);
		if (referrer != null && referrer.origin === location.origin) {
			backButton.href = "javascript:history.back()";
		}
	}
}

export default {
	init
};
